var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounEmpowering2202388(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.193,
    height: 108.193,
    viewBox: "0 0 108.193 108.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-empowering-2202388",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M614.175,166.25a1.675,1.675,0,0,0-1.675,1.675v.41a1.675,1.675,0,1,0,3.35,0v-.41a1.675,1.675,0,0,0-1.675-1.675Z",
    transform: "translate(-508.657 -134.426)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M71.675,170.021a1.675,1.675,0,0,0,1.675-1.675v-.419a1.675,1.675,0,1,0-3.35,0v.427A1.675,1.675,0,0,0,71.675,170.021Z",
    transform: "translate(-70 -134.428)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M611.53,203.7a1.675,1.675,0,0,0,1.675-1.449,6.493,6.493,0,0,1,.109-.837,1.687,1.687,0,1,0-3.35-.4c-.034.274-.069.553-.109.837a1.675,1.675,0,0,0,1.432,1.884Z",
    transform: "translate(-506.506 -161.328)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M593.671,268.11a1.675,1.675,0,0,0-2.177.929l-.31.754h0a1.675,1.675,0,1,0,3.074,1.332l.335-.837A1.676,1.676,0,0,0,593.671,268.11Z",
    transform: "translate(-491.302 -216.691)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M575.84,303.7a1.674,1.674,0,0,0,2.294-.594l.435-.762h0a1.681,1.681,0,0,0-2.915-1.675l-.41.712a1.674,1.674,0,0,0,.6,2.319Z",
    transform: "translate(-478.338 -242.434)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M606.066,237q.118-.418.226-.837a1.675,1.675,0,1,0-3.241-.837l-.209.837a1.676,1.676,0,0,0,3.232.888Z",
    transform: "translate(-500.799 -189.213)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M106.187,300.46a1.674,1.674,0,0,0-.628,2.286l.435.754a1.675,1.675,0,1,0,2.881-1.675l-.41-.712a1.674,1.674,0,0,0-2.278-.653Z",
    transform: "translate(-98.575 -242.776)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M82.166,236.421l-.209-.8a1.675,1.675,0,1,0-3.241.837q.109.427.226.837h0a1.677,1.677,0,0,0,3.232-.9Z",
    transform: "translate(-76.991 -189.456)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M92.523,272.363a1.674,1.674,0,0,0,.888-2.194l-.31-.754a1.677,1.677,0,1,0-3.107,1.264l.335.837a1.674,1.674,0,0,0,2.194.888Z",
    transform: "translate(-86.067 -216.999)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M73.538,199.818a1.674,1.674,0,0,0-1.448,1.867q.05.435.117.837a1.674,1.674,0,0,0,1.675,1.441h.234a1.675,1.675,0,0,0,1.424-1.892q-.058-.411-.109-.837h0a1.675,1.675,0,0,0-1.893-1.415Z",
    transform: "translate(-71.679 -161.555)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M101.275,481.25a5.025,5.025,0,1,0,4.352,2.512A5.025,5.025,0,0,0,101.275,481.25Zm0,6.7a1.675,1.675,0,1,1,1.184-.491A1.675,1.675,0,0,1,101.275,487.95Z",
    transform: "translate(-91.226 -389.131)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M73.35,544.175a1.675,1.675,0,1,1-1.675-1.675,1.675,1.675,0,0,1,1.675,1.675",
    transform: "translate(-70 -438.656)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M556.275,481.25a5.025,5.025,0,1,0,4.352,2.512A5.025,5.025,0,0,0,556.275,481.25Zm1.164,6.214a.95.95,0,1,1,.008,0Z",
    transform: "translate(-459.132 -389.131)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M615.85,544.175a1.675,1.675,0,1,1-1.675-1.675,1.675,1.675,0,0,1,1.675,1.675",
    transform: "translate(-508.657 -438.656)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M307.925,9.212A1.675,1.675,0,0,0,309.6,7.537V1.675a1.675,1.675,0,0,0-3.35,0V7.537a1.675,1.675,0,0,0,1.675,1.675Z",
    transform: "translate(-261.028 0.001)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M377.925,9.212A1.675,1.675,0,0,0,379.6,7.537V1.675a1.675,1.675,0,1,0-3.35,0V7.537a1.675,1.675,0,0,0,1.675,1.675Z",
    transform: "translate(-317.629 0.001)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M342.925,15.074A1.675,1.675,0,0,0,344.6,13.4V1.675a1.675,1.675,0,1,0-3.35,0V13.4a1.675,1.675,0,0,0,1.675,1.675Z",
    transform: "translate(-289.329 0.001)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M372.015,233.742a1.675,1.675,0,0,0,2.294-2.437,14.978,14.978,0,0,0-9.438-3.81,1.677,1.677,0,1,0-.167,3.35,11.591,11.591,0,0,1,7.311,2.9Z",
    transform: "translate(-307.005 -183.946)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M73.258,21.149a4.74,4.74,0,0,0,.929,5.519l.963.963a4.867,4.867,0,0,0,3.4,1.424,4.545,4.545,0,0,0,2.119-.519,4.74,4.74,0,0,0,4.547,3.282h1.391a4.74,4.74,0,0,0,4.547-3.258,4.537,4.537,0,0,0,2.119.52,4.861,4.861,0,0,0,3.392-1.449l.971-.963a4.748,4.748,0,0,0,.9-5.519,4.74,4.74,0,0,0,3.282-4.547V15.211a4.74,4.74,0,0,0-3.258-4.547,4.741,4.741,0,0,0-.929-5.511l-.963-.971a4.867,4.867,0,0,0-3.4-1.424,4.545,4.545,0,0,0-2.119.519A4.74,4.74,0,0,0,86.607-.005H85.216a4.74,4.74,0,0,0-4.547,3.258,4.537,4.537,0,0,0-2.119-.52,4.861,4.861,0,0,0-3.392,1.449l-.971.971a4.733,4.733,0,0,0-.9,5.519A4.741,4.741,0,0,0,70,15.211v1.4a4.74,4.74,0,0,0,3.258,4.539Zm.092-5.938a1.323,1.323,0,0,1,1.24-1.4h1.783a9.705,9.705,0,0,1,1.315-3.174L76.432,9.383a1.323,1.323,0,0,1,.1-1.851l1-1a1.484,1.484,0,0,1,1.039-.444,1.168,1.168,0,0,1,.837.335l1.256,1.256a9.736,9.736,0,0,1,3.149-1.306V4.585a1.323,1.323,0,0,1,1.4-1.24h1.391a1.323,1.323,0,0,1,1.4,1.24V6.368a9.705,9.705,0,0,1,3.174,1.315l1.256-1.256a1.16,1.16,0,0,1,.837-.335,1.48,1.48,0,0,1,1.013.435l1,1A1.323,1.323,0,0,1,95.4,9.4l-1.256,1.256a9.719,9.719,0,0,1,1.314,3.157h1.775a1.323,1.323,0,0,1,1.24,1.4v1.4a1.323,1.323,0,0,1-1.24,1.4H95.458a9.743,9.743,0,0,1-1.314,3.174L95.4,22.439a1.332,1.332,0,0,1-.109,1.842l-1,1a1.482,1.482,0,0,1-1.03.444,1.168,1.168,0,0,1-.837-.335l-1.256-1.256a9.733,9.733,0,0,1-3.173,1.314v1.775a1.323,1.323,0,0,1-1.382,1.24H85.216a1.323,1.323,0,0,1-1.4-1.24V25.445a9.728,9.728,0,0,1-3.174-1.315l-1.256,1.256a1.16,1.16,0,0,1-.837.335,1.48,1.48,0,0,1-1.013-.435l-1-1a1.323,1.323,0,0,1-.109-1.868l1.256-1.256A9.724,9.724,0,0,1,76.373,18H74.59a1.323,1.323,0,0,1-1.24-1.4Z",
    transform: "translate(-70 0.005)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M128.353,64.22h.092a5.993,5.993,0,1,0-.092,0Zm-1.817-7.613a1.018,1.018,0,1,0,.008,0Z",
    transform: "translate(-112.442 -42.445)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M492.314,10.667a4.741,4.741,0,0,0-.929-5.511l-.963-.971a4.867,4.867,0,0,0-3.4-1.424,4.546,4.546,0,0,0-2.119.519A4.74,4.74,0,0,0,480.355,0h-1.391a4.74,4.74,0,0,0-4.547,3.258,4.537,4.537,0,0,0-2.119-.52,4.861,4.861,0,0,0-3.392,1.449l-.971.971a4.733,4.733,0,0,0-.9,5.519,4.741,4.741,0,0,0-3.282,4.539v1.4a4.74,4.74,0,0,0,3.258,4.547,4.74,4.74,0,0,0,.929,5.511l.963.963a4.867,4.867,0,0,0,3.4,1.424,4.546,4.546,0,0,0,2.119-.519,4.74,4.74,0,0,0,4.547,3.282h1.391a4.74,4.74,0,0,0,4.547-3.258,4.537,4.537,0,0,0,2.119.52,4.861,4.861,0,0,0,3.392-1.449l.971-.963a4.748,4.748,0,0,0,.9-5.519,4.74,4.74,0,0,0,3.283-4.547V15.214a4.74,4.74,0,0,0-3.258-4.547Zm-.092,5.938a1.324,1.324,0,0,1-1.24,1.4h-1.775a9.744,9.744,0,0,1-1.315,3.174l1.256,1.256a1.332,1.332,0,0,1-.109,1.851l-1,1a1.482,1.482,0,0,1-1.03.444,1.168,1.168,0,0,1-.837-.335l-1.256-1.256a9.733,9.733,0,0,1-3.173,1.314v1.775a1.323,1.323,0,0,1-1.382,1.24h-1.391a1.323,1.323,0,0,1-1.4-1.24V25.448a9.728,9.728,0,0,1-3.174-1.315l-1.256,1.256a1.161,1.161,0,0,1-.837.335,1.48,1.48,0,0,1-1.013-.435l-1-1a1.323,1.323,0,0,1-.109-1.868l1.256-1.256a9.733,9.733,0,0,1-1.315-3.173h-1.775A1.324,1.324,0,0,1,467.1,16.6V15.214a1.324,1.324,0,0,1,1.24-1.4h1.775a9.7,9.7,0,0,1,1.315-3.174l-1.256-1.256a1.323,1.323,0,0,1,.109-1.851l1-1a1.484,1.484,0,0,1,1.039-.444,1.168,1.168,0,0,1,.837.335l1.256,1.256a9.735,9.735,0,0,1,3.174-1.314V4.587a1.323,1.323,0,0,1,1.373-1.24h1.391a1.323,1.323,0,0,1,1.4,1.24V6.371a9.705,9.705,0,0,1,3.174,1.315l1.256-1.256a1.16,1.16,0,0,1,.837-.335,1.48,1.48,0,0,1,1.013.435l1,1a1.323,1.323,0,0,1,.109,1.868l-1.256,1.256a9.716,9.716,0,0,1,1.315,3.173h1.775a1.324,1.324,0,0,1,1.24,1.382Z",
    transform: "translate(-388.379 0.003)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M521.994,52.5a5.863,5.863,0,0,0,.109,11.724h.092a5.863,5.863,0,1,0-.2-11.724Zm1.918,7.613a2.517,2.517,0,1,1,.7-1.75A2.513,2.513,0,0,1,523.912,60.108Z",
    transform: "translate(-430.823 -42.445)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M401.47,544.175a1.675,1.675,0,1,1-1.675-1.675,1.675,1.675,0,0,1,1.675,1.675",
    transform: "translate(-335.313 -438.656)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M436.47,272.925a1.675,1.675,0,1,1-1.675-1.675,1.675,1.675,0,0,1,1.675,1.675",
    transform: "translate(-363.613 -219.328)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M214.915,186.335a5.636,5.636,0,0,0,5.477-5.77v-4.087a5.636,5.636,0,0,0-5.477-5.77h-4.187a29.4,29.4,0,0,0-3.182-7.369l2.864-2.747h0a5.024,5.024,0,0,0,1.608-3.651,5.938,5.938,0,0,0-1.876-4.238l-3.023-2.9a5.862,5.862,0,0,0-8.031-.318l-2.981,2.814a32.13,32.13,0,0,0-7.814-3.09v-3.9c0-2.931-2.672-5.309-5.962-5.309H178.06c-3.291,0-5.962,2.387-5.962,5.309v3.9a32.108,32.108,0,0,0-7.814,3.09l-2.939-2.814a5.862,5.862,0,0,0-8.039.326l-3.023,2.9h0a5.926,5.926,0,0,0-1.91,4.229,5.024,5.024,0,0,0,1.541,3.659l2.864,2.738a29.384,29.384,0,0,0-3.182,7.369h-4.187a5.636,5.636,0,0,0-5.41,5.77v4.087a5.636,5.636,0,0,0,5.477,5.77h4.187a29.472,29.472,0,0,0,3.191,7.369l-2.873,2.738a5.027,5.027,0,0,0-1.608,3.659,5.938,5.938,0,0,0,1.876,4.238l3.031,2.9a5.863,5.863,0,0,0,8.039.318l2.437-2.337q-.971-1.507-1.75-2.965l-3,2.873h0a2.57,2.57,0,0,1-3.408-.318l-3.04-2.889a2.581,2.581,0,0,1-.837-1.818,1.673,1.673,0,0,1,.5-1.231l4.883-4.664-.779-1.172a26.156,26.156,0,0,1-3.769-8.743l-.293-1.306h-6.791a2.3,2.3,0,0,1-2.127-2.42v-4.087a2.3,2.3,0,0,1,2.127-2.42h6.791l.293-1.306a26.061,26.061,0,0,1,3.794-8.743l.787-1.172-4.874-4.664a1.676,1.676,0,0,1-.544-1.231,2.572,2.572,0,0,1,.837-1.818l3.023-2.889a2.572,2.572,0,0,1,3.409-.327l4.79,4.581,1.1-.678h0a28.821,28.821,0,0,1,9.212-3.643l1.332-.277v-6.582c0-1.063,1.2-1.96,2.612-1.96H182.3c1.415,0,2.612.9,2.612,1.96v6.582l1.332.277a28.79,28.79,0,0,1,9.212,3.643l1.1.678,4.79-4.581h0a2.514,2.514,0,0,1,3.409.319l3.073,2.9a2.581,2.581,0,0,1,.837,1.818,1.673,1.673,0,0,1-.5,1.231l-4.874,4.664.787,1.172h0a26.1,26.1,0,0,1,3.752,8.743l.3,1.3h6.783a2.294,2.294,0,0,1,2.127,2.429v4.087a2.3,2.3,0,0,1-2.127,2.42h-6.783l-.3,1.306a26.207,26.207,0,0,1-3.794,8.751l-.779,1.172,4.874,4.656h0a1.673,1.673,0,0,1,.5,1.231,2.581,2.581,0,0,1-.837,1.818l-3.023,2.889a2.571,2.571,0,0,1-3.408.327l-2.144-2.052-2.06,2.663,1.892,1.817h0a5.862,5.862,0,0,0,8.031-.327l3.023-2.9a5.943,5.943,0,0,0,1.868-4.238,5.025,5.025,0,0,0-1.541-3.651l-2.856-2.738a29.451,29.451,0,0,0,3.182-7.369Z",
    transform: "translate(-126.598 -113.2)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M286.169,292.905l.176-.159c1.608-1.6,1.5-4.48,1.5-4.5v-5.477a1.676,1.676,0,0,0-.117-.62,7.023,7.023,0,0,0-4.187-3.961,5.988,5.988,0,0,0-4.237.4,8.65,8.65,0,0,0-3.6-3.617,7.785,7.785,0,0,0-5.653-.419,8.55,8.55,0,0,0-5.025-3.124,7.689,7.689,0,0,0-5.485,1.332,4.4,4.4,0,0,0-2.228-1.256c-1.675-.36-3.425.327-5.209,2.026h0A3.957,3.957,0,0,0,251,276.19V286.9a7.662,7.662,0,0,0-1.139,1.256,1.674,1.674,0,0,0-.277.62c-.1.444-2.236,10.962,7.269,23.523h0a1.238,1.238,0,0,1,.134.4V324.51a1.675,1.675,0,1,0,3.35,0V312.694a4.315,4.315,0,0,0-.837-2.412c-7.621-10.049-6.967-18.683-6.7-20.468,1.105-1.273,3.735-2.73,9.974-2.989.57,0,1.96.042,2.412,1.164,0,0,.1,1.2-2.956,4.187a18.969,18.969,0,0,0-4.128-1.541,1.678,1.678,0,1,0-.837,3.25c4.028,1.021,6.574,2.965,7.152,5.46h0a1.673,1.673,0,0,0,3.258-.762A8.889,8.889,0,0,0,265,294.118c2.981-3.031,4.053-5.452,3.274-7.378-.837-2.127-3.023-3.35-5.661-3.266a26.578,26.578,0,0,0-8.265,1.457v-8.727a1.578,1.578,0,0,1,.076-.259c.888-.837,1.675-1.273,2.186-1.172s.888.728,1,1a1.674,1.674,0,0,0,2.654.628c1.524-1.323,2.947-1.892,4.246-1.675a5.854,5.854,0,0,1,3.484,2.63h0a1.675,1.675,0,0,0,2.06.728,5.109,5.109,0,0,1,4.187-.126,6.231,6.231,0,0,1,2.713,3.425,1.675,1.675,0,0,0,2.58.913,3.85,3.85,0,0,1,3.09-.938h0a3.555,3.555,0,0,1,1.868,1.784v5.351c.042.971-.251,2.186-1.415,2.219-.837,0-2-.293-1.918-1.332l.076-2.077a1.68,1.68,0,0,0-3.358-.117l-.084,1.943v.419a1.675,1.675,0,0,1-1.675,1.047c-.636-.159-1.934-.762-1.575-3.082A1.694,1.694,0,0,0,271.2,287c-.67,4.338,2.2,6.5,4.3,6.892a4.434,4.434,0,0,0,.837.067,4.679,4.679,0,0,0,2.965-1.03,5.4,5.4,0,0,0,3.3,1.013h.226v10.351a1.216,1.216,0,0,1-.159.461l-3.986,5.1a4.417,4.417,0,0,0-.879,2.512v5.862a1.675,1.675,0,1,0,3.35,0v-5.82a1.234,1.234,0,0,1,.159-.461l3.978-5.134a4.4,4.4,0,0,0,.879-2.512Z",
    transform: "translate(-214.986 -219.411)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M335.85,443.545a1.675,1.675,0,1,1-1.675-1.675,1.675,1.675,0,0,1,1.675,1.675",
    transform: "translate(-282.254 -357.288)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M334.175,476.88a1.675,1.675,0,0,0-1.675,1.675v7.537a1.675,1.675,0,1,0,3.35,0v-7.537a1.675,1.675,0,0,0-1.675-1.675Z",
    transform: "translate(-282.254 -385.597)",
    fill: "#0f8a45",
    stroke: "#0f8a45",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounEmpowering2202388);
export default __webpack_public_path__ + "static/media/noun-empowering-2202388.1571426416a2a3d3db0935192802994a.svg";
export { ForwardRef as ReactComponent };